<template>
  <header class="header">
    <div class="header-content">
      <div class="header-content-nav">
        <div class="header-content-nav-logo">QNX</div>
        <div
          v-for="(title, i) in ['Swap', 'Liquidity', 'Strategies', 'QNI', 'More']"
          :key="i"
          class="header-content-nav-btn header-desktop-content"
        >
          <span v-if="!i">Soon: </span>
          <span class="header-content-nav-btn-text">{{ title }}</span>
          <svg v-if="i === 4" class="header-content-nav-btn__icon" width="11" height="7" viewBox="0 0 11 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_4809_3348)">
              <mask id="path-1-inside-1_4809_3348" fill="white">
                <path d="M-626 -37H1294V47H-626V-37Z"/>
              </mask>
              <path d="M1294 46H-626V48H1294V46Z" fill="#101010" mask="url(#path-1-inside-1_4809_3348)"/>
              <path d="M9.35938 1.5L5.35938 5.5L1.35938 1.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
            <defs>
              <clipPath id="clip0_4809_3348">
                <rect width="11" height="7" fill="white"/>
              </clipPath>
            </defs>
          </svg>

        </div>
      </div>
      <div class="header-content-actions">
        <div v-if="false" class="header-price header-desktop-content">
          $1.277
        </div>
        <button
          class="header-content-action-btn header-content-action-btn-mobile"
        >
          <img src="./assets/icons/header/network.svg" alt="" />
        </button>
        <button class="header-content-action-btn">
          <img src="./assets/icons/header/settings.svg" alt="" />
        </button>
        <button disabled class="header-content-connect-btn">
          <span>
            <span>Connect</span
            ><span class="header-desktop-content"> Wallet</span>
          </span>
          <img
            class="header-desktop-content"
            src="./assets/icons/header/connect.svg"
            alt=""
          />
        </button>
      </div>
    </div>
  </header>
  <main>
    <div class="headline">
      <div class="headline-content">
        <div class="headline-title">
          Everyone's<br />
          Favorite DEX
        </div>
        <div class="headline-learn">
          <div class="headline-subtitle">
            TRADE, EARN, OWN CRYPTO<br />
            SWITCH TO AUTOPILOT WITH<br />
            MULTICHAIN ADVANCED LIQUIDITY<br />
            MANAGEMENT ON OUR DEX
          </div>
          <a
            href="https://docs.quantex.fi/qnx"
            target="_blank"
            class="learn-more-btn"
          >
            Learn More
            <svg
              width="44"
              height="44"
              viewBox="0 0 44 44"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M36.7789 6.76023C33.7644 3.74968 29.9247 1.70013 25.7452 0.870641C21.5657 0.0411561 17.234 0.468981 13.2977 2.10004C9.36134 3.73109 5.99709 6.49215 3.63019 10.0342C1.26329 13.5763 0 17.7403 0 21.9999C0 26.2596 1.26329 30.4236 3.63019 33.9656C5.99709 37.5077 9.36134 40.2687 13.2977 41.8998C17.234 43.5309 21.5657 43.9587 25.7452 43.1292C29.9247 42.2997 33.7644 40.2502 36.7789 37.2396C40.8161 33.1946 43.0833 27.7139 43.0833 21.9999C43.0833 16.2859 40.8161 10.8053 36.7789 6.76023ZM21.0503 23.1733L14.4198 29.8015C14.2658 29.9555 14.083 30.0776 13.8817 30.1609C13.6805 30.2442 13.4649 30.2871 13.2471 30.2871C13.0292 30.2871 12.8136 30.2442 12.6124 30.1609C12.4111 30.0776 12.2283 29.9555 12.0743 29.8015C11.9203 29.6476 11.7981 29.4648 11.7148 29.2636C11.6314 29.0625 11.5885 28.8469 11.5885 28.6292C11.5885 28.4114 11.6314 28.1958 11.7148 27.9947C11.7981 27.7935 11.9203 27.6108 12.0743 27.4568L17.532 22.001L12.0701 16.541C11.9161 16.387 11.794 16.2042 11.7106 16.0031C11.6273 15.8019 11.5844 15.5863 11.5844 15.3686C11.5844 15.1509 11.6273 14.9353 11.7106 14.7341C11.794 14.533 11.9161 14.3502 12.0701 14.1962C12.2242 14.0423 12.407 13.9202 12.6082 13.8368C12.8094 13.7535 13.0251 13.7106 13.2429 13.7106C13.4607 13.7106 13.6764 13.7535 13.8776 13.8368C14.0788 13.9202 14.2617 14.0423 14.4157 14.1962L21.0461 20.8244C21.2011 20.9781 21.3242 21.1609 21.4084 21.3623C21.4925 21.5637 21.536 21.7798 21.5364 21.998C21.5368 22.2163 21.4941 22.4325 21.4106 22.6342C21.3272 22.8358 21.2047 23.0191 21.0503 23.1733ZM32.6535 23.1733L26.0231 29.8015C25.7121 30.1125 25.2902 30.2871 24.8503 30.2871C24.4105 30.2871 23.9886 30.1125 23.6776 29.8015C23.3665 29.4906 23.1918 29.0689 23.1918 28.6292C23.1918 28.1894 23.3665 27.7677 23.6776 27.4568L29.1415 22.001L23.6796 16.541C23.5256 16.387 23.4035 16.2042 23.3201 16.0031C23.2368 15.8019 23.1939 15.5863 23.1939 15.3686C23.1939 15.1509 23.2368 14.9353 23.3201 14.7341C23.4035 14.533 23.5256 14.3502 23.6796 14.1962C23.8337 14.0423 24.0165 13.9202 24.2177 13.8368C24.4189 13.7535 24.6346 13.7106 24.8524 13.7106C25.0702 13.7106 25.2859 13.7535 25.4871 13.8368C25.6883 13.9202 25.8712 14.0423 26.0252 14.1962L32.6556 20.8244C32.8105 20.9783 32.9334 21.1612 33.0174 21.3627C33.1014 21.5641 33.1447 21.7802 33.1449 21.9985C33.1451 22.2167 33.1021 22.4329 33.0185 22.6345C32.9349 22.8361 32.8123 23.0192 32.6577 23.1733H32.6535Z"
              />
            </svg>
          </a>
        </div>
        <div class="headline-img">
          <animation-player
            v-show="isDarkMode"
            :src="videos.black"
            id="headline-video-black"
          />
          <animation-player
            v-show="!isDarkMode"
            :src="videos.white"
            id="headline-video-white"
          />
        </div>
        <div class="headline-currencies">
          <div class="headline-currencies-icon">
            <img :src="require(`./assets/icons/eth.svg`)" alt="" />
          </div>
          <div>
            The Future of Decentralized Trading:<br />
            Discover Quantex's Powerful Diversification Tools
          </div>
        </div>
      </div>
    </div>
    <div class="cards">
      <div class="card-white">
        <div class="logo-wrap">
          <img src="./assets/icons/logo.svg" alt="" class="logo-img" />
          <div class="title-small">Discover the QUANTEX Ecosystem</div>
        </div>
        <div class="title-medium">Swap & Trade</div>
        <div class="trade-items">
          <div class="trade-item">
            <img class="trade-item-icon" src="./assets/icons/swap.svg" alt="" />
            <div class="trade-item-title">Swap & Trade Perpetual</div>
          </div>
          <div class="trade-item">
            <img
              class="trade-item-icon"
              src="./assets/icons/liquidity.svg"
              alt=""
            />
            <div class="trade-item-title">Liquidity</div>
          </div>
          <div class="trade-item">
            <img
              class="trade-item-icon"
              src="./assets/icons/bridge.svg"
              alt=""
            />
            <div class="trade-item-title">Bridge</div>
          </div>
          <div class="trade-item">
            <img
              class="trade-item-icon"
              src="./assets/icons/buy-crypto.svg"
              alt=""
            />
            <div class="trade-item-title">Strategy<br />and qni</div>
          </div>
        </div>
        <div class="trade-desc-wrap">
          <div class="trade-desc-chip">01/4</div>
          <div class="trade-desc">
            <span>
              SWAP CRYPTO AND EMPOWER YOUR PORTFOLIO WITH QNI:<br />
              DIVERSIFY SEAMLESSLY AND EARN YOUR SHARE OF THE PROTOCOL'S TREASURY!
            </span>
            <div class="trade-desc-link">
              <span>Coming soon</span>
              <img src="./assets/icons/arrow-right.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="earn-items-wrap">
          <div class="title-medium">Earn</div>
          <div class="earn-items">
            <div class="earn-item">
              <img
                src="./assets/icons/farm.svg"
                alt=""
                class="earn-item-icon"
              />
              <div class="earn-item-desc-wrap">
                <div class="earn-item-desc-title">Farm</div>
                <div class="earn-item-desc">Harvest</div>
                <div class="earn-item-desc-link">
                  <span>TBA</span>
                  <img src="./assets/icons/arrow-right.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="earn-item">
              <img
                src="./assets/icons/pools.svg"
                alt=""
                class="earn-item-icon"
              />
              <div class="earn-item-desc-wrap">
                <div class="earn-item-desc-title">pools</div>
                <div class="earn-item-desc">Earn various rewards</div>
                <div class="earn-item-desc-link">
                  <span>TBA</span>
                  <img src="./assets/icons/arrow-right.svg" alt="" />
                </div>
              </div>
            </div>
            <div class="earn-item">
              <img
                src="./assets/icons/staking.svg"
                alt=""
                class="earn-item-icon"
              />
              <div class="earn-item-desc-wrap">
                <div class="earn-item-desc-title">QNI</div>
                <div class="earn-item-desc">Diversify and earn</div>
                <div class="earn-item-desc-link">
                  <span>TBA</span>
                  <img src="./assets/icons/arrow-right.svg" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-gray">
        <div class="ecosystem-title-wrap">
          <div class="title-small">
            Unlock the Full Potential of DeFi with
            <span class="title-large">QUANTEX</span>
          </div>
          <div class="ecosystem-subtitle">
            Experience the power of community ownership, global governance, and
            explore use cases within the QUANTEX ecosystem
          </div>
          <div class="ecosystem-actions">
            <div class="dark-button">Coming Soon</div>
            <div class="icon-button">
              <span>LEARN</span>
              <img src="./assets/icons/light/learn-more.svg" alt="" />
            </div>
          </div>
        </div>
        <div class="ecosystem-cards-wrap">
          <div class="ecosystem-cards-title">
            <span class="ecosystem-cards-title-label">Quantex</span><br />
            Ecosystem<br />
            Experience<br />
          </div>
          <div class="ecosystem-cards">
            <div v-for="i in 15" :key="i" class="ecosystem-card">
              <div class="ecosystem-card-title">Quantex foundation</div>
              <img
                class="ecosystem-card-img"
                src="./assets/images/card-img.png"
                alt=""
              />
              <div class="ecosystem-card-desc">
                <template v-if="false"
                  >A non-profit organization headquartered in Zug, Switzerland,
                  dedicated to the decentralization, growth, and security of the
                  Solana network</template
                >
              </div>
              <div>
                <div class="ecosystem-card-link">Coming Soon</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-social-wrap">
        <div class="card-social">
          <div class="social-title">Join our Community</div>
          <div class="social-desc">
            Together, Let's Power Up the Quantex Community!
          </div>
          <div class="blog-wrap">
            <div class="blog-social-list">
              <a
                v-for="(item, i) in blogSocialItems"
                :key="i"
                :href="item.link"
                target="_blank"
                class="blog-social-item"
              >
                <img :src="item.icon" alt="" class="blog-social-item-icon" />
                <div class="blog-social-item-title">{{ item.name }}</div>
              </a>
            </div>
            <div class="blog">
              <div class="blog-title">Latest Blog Post</div>
              <img src="./assets/images/blog-img.png" alt="" class="blog-img" />
              <div class="blog-date">2023-09-29</div>
              <div class="blog-desc">
                Quantex DeFi Galaxy Tour: Mars Mystique - Unlock Your Winning
                Potential
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-join">
        <!--        <img-->
        <!--          src="./assets/images/quantex-img.png"-->
        <!--          alt=""-->
        <!--          class="card-join-img"-->
        <!--        />-->
        <div class="card-join-img-wrap">
          <animation-player
            :src="footerVideo.white"
            id="headline-footer-video-white"
          />
        </div>
        <div class="card-join-title">Join Everyone's Favorite DEX Now!</div>
        <button disabled class="dark-button">Connect Wallet</button>
      </div>
    </div>
  </main>
  <footer class="footer">
    <div class="footer-content">
      <div class="footer-title">QNX</div>
      <div class="footer-spacer-1">&nbsp;</div>
      <div class="footer-token">
        <div v-if="false" class="footer-token-price">$1.277</div>
        <div class="footer-token-btn">
          <span>Buy</span>
          <img src="./assets/icons/arrow-right.svg" alt="" />
        </div>
      </div>
      <div class="footer-switcher">
        <theme-switcher v-model="isDarkMode" />
      </div>
      <div class="footer-social-list">
        <a
          v-for="(item, i) in footerIconsItems"
          :key="i"
          class="footer-social-item"
          :href="item.link"
          target="_blank"
        >
          <img :src="item.icon" alt="" />
        </a>
      </div>
      <div class="footer-spacer-2">&nbsp;</div>
      <div class="footer-about footer-list">
        <div class="footer-list-title">About</div>
        <a
          v-for="(item, i) in footerAboutItems"
          :key="i"
          :href="item.link"
          target="_blank"
          class="footer-list-item"
        >
          {{ item.name }}
        </a>
      </div>
      <div class="footer-devs footer-list">
        <div class="footer-list-title">Developers</div>
        <a
          v-for="(item, i) in footerDevItems"
          :key="i"
          class="footer-list-item"
          :href="item.link"
          target="_blank"
        >
          {{ item.name }}
        </a>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed, ref } from "vue";
import ThemeSwitcher from "@/components/ThemeSwitcher.vue";
import AnimationPlayer from "@/components/AnimationPlayer.vue";

import videoBlack640 from "@/assets/videos/headline/640/black.mp4";
import videoWhite640 from "@/assets/videos/headline/640/white.mp4";
import videoBlack1080 from "@/assets/videos/headline/1080/black.mp4";
import videoWhite1080 from "@/assets/videos/headline/1080/white.mp4";

import footerVideo1080 from "@/assets/videos/footer/1080/video.mp4";
import footerVideo640 from "@/assets/videos/footer/640/video.mp4";

import twitterIcon from "@/assets/icons/social/twitter.svg";
import discordIcon from "@/assets/icons/social/discord.svg";
import gitbookIcon from "@/assets/icons/social/gitbook.svg";

import footTwitterIcon from "@/assets/icons/footer/twitter.svg";
import footGithubIcon from "@/assets/icons/footer/github.svg";
import footDiscordIcon from "@/assets/icons/footer/discord.svg";
import footGitbookIcon from "@/assets/icons/footer/gitbook.svg";

const videosConfig = {
  [640]: { black: videoBlack640, white: videoWhite640 },
  [1080]: { black: videoBlack1080, white: videoWhite1080, minWidth: 480 },
};

const footerVideosConfig = {
  [640]: { white: footerVideo640 },
  [1080]: { white: footerVideo1080, minWidth: 480 },
};

const blogSocialItems = [
  { name: "Twitter", icon: twitterIcon, link: "https://twitter.com/QuantexFi" },
  { name: "Discord", icon: discordIcon, link: "https://discord.gg/DZdQqUcc" },
  { name: "Gitbook", icon: gitbookIcon, link: "https://docs.quantex.fi/qnx" },
];

const footerIconsItems = [
  { icon: footTwitterIcon, link: "https://twitter.com/QuantexFi" },
  {
    icon: footGithubIcon,
    link: "https://github.com/dev010708/quantex_front_app",
  },
  { icon: footDiscordIcon, link: "https://discord.gg/DZdQqUcc" },
  { icon: footGitbookIcon, link: "https://docs.quantex.fi/qnx" },
];

const footerAboutItems = [
  { name: "Contact", link: "#" },
  { name: "Gitbook", link: "https://docs.quantex.fi/qnx" },
  { name: "Discord", link: "https://discord.gg/DZdQqUcc" },
  { name: "Twitter", link: "https://twitter.com/QuantexFi" },
];

const footerDevItems = [
  // { name: "Github", link: "https://github.com/dev010708/quantex_front_app" },
  { name: "Documentation", link: "https://docs.quantex.fi/qnx" },
];

const getVideo = (config) => {
  const width = window.screen.width;
  const configEntries = Object.entries(config);
  const size =
    configEntries.findLast(([, item]) => (item.minWidth || 0) < width)[0] ||
    configEntries.at(-1)[0];
  return config[size];
};

const videos = computed(() => getVideo(videosConfig));
const footerVideo = computed(() => getVideo(footerVideosConfig));

const isDarkMode = ref(true);

const theme = computed(() => ({
  headlineText: isDarkMode.value ? "#ffffff" : "#000000",
  headlineBg: isDarkMode.value ? "#000000" : "#ffffff",
  headerHeight: "84px",
}));
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;
  outline: none;
}

button {
  background: transparent;
  border: none;
  outline: none;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
}

button:disabled {
  cursor: default;
  opacity: 0.35;
}

.dark-button {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #1f1f1f;
  color: #ffffff;
  padding: 0 24px;
  height: 48px;
  border-radius: 16px;
}

.icon-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  color: #504b53;
  padding: 0 0 0 24px;
}

.icon-button > img {
  width: 33px;
  margin-left: 14px;
}

.header {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  color: v-bind(theme [ "headlineText"]);
  background: v-bind(theme [ "headlineBg"]);
  padding: 11px 16px 17px 16px;
  height: v-bind(theme [ "headerHeight"]);
  box-sizing: border-box;
  z-index: 1000;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1920px;
}

.header-content-nav {
  display: flex;
  align-items: center;
}

.header-content-nav-logo {
  font-weight: 600;
  font-size: 26px;
  padding: 7px 10px 7px 0;

  background: linear-gradient(#000000, #ffffff);
  background-clip: text;
  color: transparent;
  line-height: 1;

  @media (min-width: 1280px) {
    padding-left: 107px;
    padding-right: 47px;
  }
}

.header-content-nav-btn {
  padding: 6px 16px;
  font-size: 15px;
  text-transform: uppercase;

  &:last-child {
    display: flex;
    align-items: center;
    gap: 4px;

    .header-content-nav-btn__icon {
      margin-top: -3px;
      opacity: 0.35;
    }
  }
}

.header-content-nav-btn-text {
  opacity: 0.35;
}

.header-content-actions {
  display: flex;
  align-items: center;
}

.header-content-action-btn {
  display: flex;
  padding: 12px 12px;
}

.header-price {
  font-size: 22px;
  padding: 0 12px;
}

.header-content-connect-btn {
  display: flex;
  align-items: center;
  padding: 17px 10px;
  border-radius: 10px;
  text-transform: uppercase;
  line-height: 16px;
  font-size: 16px;
  font-weight: 500;
  background: v-bind(theme [ "headlineText"]);
  color: v-bind(theme [ "headlineBg"]);
  margin-left: 12px;
  @media (min-width: 1024px) {
    padding: 19px 20px;
  }
}

.header-desktop-content {
  display: none;
  @media (min-width: 1024px) {
    display: inline;
  }
}

.header-content-connect-btn > img {
  margin-left: 10px;
}

.header-content-action-btn-mobile {
  @media (min-width: 1024px) {
    display: none;
  }
}

.headline {
  display: flex;
  align-items: center;
  justify-content: center;
  background: v-bind(theme [ "headlineBg"]);
  min-height: 100vh;
  box-sizing: border-box;

  @media (min-width: 768px) {
    min-height: calc(100vh + 40px);
    border-bottom-left-radius: 40px;
    border-bottom-right-radius: 40px;
  }
}

.headline-content {
  display: grid;
  max-width: 100%;
  width: 1418px;
  color: v-bind(theme [ "headlineText"]);
  padding: 0 20px 24px;
  margin-top: calc(v-bind(theme [ "headerHeight"]) + 50px);
  grid-template-areas:
    "title"
    "img"
    "learn"
    "currencies";

  @media (min-width: 768px) {
    grid-template-columns: 280px auto 280px;
    align-items: center;
    align-content: center;
    grid-template-areas:
      "title img currencies"
      "learn img currencies";
    margin-top: 0;
  }

  @media (min-width: 1280px) {
    grid-template-columns: minmax(370px, 1fr) minmax(auto, 678px) minmax(
        370px,
        1fr
      );
  }
}

.headline-title {
  font-size: 36px;
  font-weight: 300;
  text-transform: uppercase;
  line-height: 36px;
  grid-area: title;
  align-self: flex-end;

  @media (min-width: 768px) {
    margin-bottom: 22px;
  }
}

.headline-learn {
  display: grid;
  gap: 16px;
  grid-area: learn;
  align-self: flex-start;
}

.learn-more-btn {
  position: relative;
  display: flex;
  align-items: center;
  height: 44px;
  width: 180px;
  font-size: 16px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 0 10px;
  border-radius: 16px;
  border: 1px #504b53 solid;
  box-sizing: border-box;
}

.learn-more-btn > svg {
  position: absolute;
  right: 0;
  fill: v-bind(theme [ "headlineText"]);
  z-index: 10;
  width: 42px;
  height: 42px;
}

.learn-more-btn::after {
  content: "";
  position: absolute;
  left: -1px;
  top: -1px;
  right: -1px;
  bottom: -1px;
  z-index: 1;
  background: linear-gradient(
    90deg,
    transparent 0%,
    v-bind(theme [ "headlineBg"]) 100%
  );
}

.headline-subtitle {
  font-size: 16px;
  text-transform: uppercase;
  white-space: pre-line;
}

.headline-currencies {
  display: grid;
  grid-template-columns: 52px auto;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
  align-self: center;
  justify-self: center;
  margin-top: 116px;
  text-transform: uppercase;
  color: v-bind(theme [ "headlineText"]);
  border-radius: 40px;
  outline: 1px solid v-bind(theme [ "headlineText"]);
  outline-offset: -1px;
  padding-right: 24px;
  text-align: right;
  font-size: 10px;
  width: auto;
  max-width: 100%;
  box-sizing: border-box;

  grid-area: currencies;

  @media (min-width: 768px) {
    margin-top: 0;
  }

  @media (min-width: 1280px) {
    font-size: 14px;
    grid-template-columns: 80px auto;
  }
}

.headline-currencies-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 52px;
  border-radius: inherit;
  background: v-bind(theme[ "headlineText"]);
  @media (min-width: 1280px) {
    height: 80px;
  }
}

.headline-img {
  position: relative;
  grid-area: img;
}

.headline-img::before {
  content: "";
  display: block;
  padding-top: 100%;
}

.cards {
  display: grid;
  justify-items: center;
  background-size: 100% auto;
}

.card-white {
  display: grid;
  width: 100%;
  max-width: 1200px;
}

.card-gray {
  display: grid;
  justify-items: center;
  width: 100%;
  background: #f8f8f8;
  overflow: hidden;
  border-top: 1px #ffffff solid;
  border-bottom: 1px #ffffff solid;
  padding-bottom: 46px;
  @media (min-width: 768px) {
    padding-bottom: 88px;
  }
}

.card-social-wrap {
  display: flex;
  justify-content: center;
  width: 100%;
  background: url("./assets/images/bg-center.png") no-repeat;
  background-size: 100% auto;
}

.card-social {
  margin-top: 84px;
  max-width: 936px;
  width: calc(100% - 32px);
  border-radius: 20px;
  margin-bottom: 58px;
  box-shadow: 0 20px 40px 0 rgba(0, 0, 0, 0.1);
  padding: 20px;
  box-sizing: border-box;
  backdrop-filter: blur(20px);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.5) 0%,
    transparent 100%
  );

  @media (min-width: 768px) {
    margin-top: 150px;
    box-shadow: none;
  }
}

.card-join {
  display: grid;
  justify-items: center;
  //background: url("./assets/images/bg-bottom.png") no-repeat bottom;
  //background-size: 100% auto;
  width: 100%;
  padding: 0 26px 68px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding-bottom: 259px;
  }
}

.card-join > .dark-button {
  max-width: 306px;
  width: 100%;
}

.card-join-title {
  font-size: 32px;
  font-weight: 300;
  color: #504b53;
  text-transform: uppercase;
  text-align: center;
  line-height: 34px;
  margin-bottom: 24px;

  @media (min-width: 768px) {
    font-size: 62px;
    margin-bottom: 118px;
    line-height: 60px;
  }
}

.card-join-img-wrap {
  position: relative;
  max-width: 586px;
  width: 100%;
}

.card-join-img-wrap::before {
  content: "";
  display: block;
  padding-top: 100%;
}

.logo-wrap {
  display: grid;
  justify-items: center;
  gap: 12px;
  margin: 160px 0 120px;
  padding: 0 24px;
  text-align: center;

  @media (min-width: 768px) {
    gap: 26px;
    margin: 160px 0 210px;
  }
}

.logo-img {
  width: 37px;
}

.trade-items {
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr 1fr;
  padding: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: 1fr;
    width: min-content;
  }
}

.trade-item {
  display: grid;
  align-content: center;
  justify-items: center;
  gap: 24px;
  padding: 20px;
  background: #ffffff;
  border-radius: 10px;
  box-sizing: border-box;

  @media (min-width: 768px) {
    width: 142px;
    height: 142px;
  }
  transition: box-shadow 0.2s;
}

.trade-item:hover {
  box-shadow: 12px 12px 18px 0 rgba(164, 164, 186, 0.2);
}

.trade-item-icon {
}

.trade-item-title {
  font-size: 14px;
  text-transform: uppercase;
  text-align: center;
}

.trade-desc-wrap {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 12px;
  align-items: flex-start;
  padding: 20px 24px;
  box-sizing: border-box;
  width: 100%;
  max-width: max-content;
  margin-bottom: 68px;

  @media (min-width: 768px) {
    margin-bottom: 255px;
  }
}

.trade-desc {
  font-size: 16px;
  text-transform: uppercase;
  color: #504b53;
}

.trade-desc-chip {
  border: 2px solid #000000;
  background: rgba(0, 0, 0, 0.1);
  border-radius: 32px;
  padding: 4px 26px;
  margin-top: 24px;
  box-shadow: 1px -1px 60px 0 rgba(164, 164, 186, 0.3),
    0 4px 4px 0 rgba(164, 164, 186, 1);

  @media (min-width: 768px) {
    margin-top: 0;
  }
}

.trade-desc-link {
  display: flex;
  margin-top: 8px;
  font-weight: 500;
}

.title-small {
  font-size: 18px;
  line-height: 32px;
  text-transform: uppercase;
  @media (min-width: 768px) {
    font-size: 34px;
  }
}

.title-medium {
  font-size: 32px;
  font-weight: 300;
  text-transform: uppercase;
  line-height: 60px;
  padding-left: 20px;
}

.title-large {
  font-size: 26px;

  @media (min-width: 768px) {
    font-size: 40px;
  }
}

.earn-items-wrap {
  margin-bottom: 54px;
  @media (min-width: 768px) {
    margin-bottom: 195px;
    max-width: 1055px;
    width: 100%;
    justify-self: flex-end;
  }
}

.earn-items {
  display: grid;
  gap: 37px;
  padding-left: 42px;
  padding-right: 24px;
  box-sizing: border-box;
  margin-top: 20px;

  @media (min-width: 768px) {
    margin-top: 40px;
    grid-template-columns: 1fr 1fr 1fr;
    padding-left: 16px;
  }
}

.earn-item {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 18px;
  font-size: 14px;
  text-transform: uppercase;
}

.earn-item-icon {
  width: 54px;
}

.earn-item-desc-wrap {
}

.earn-item-desc-title {
  font-weight: 500;
}

.earn-item-desc {
  color: #504b53;
}

.earn-item-desc-link {
  display: flex;
  align-items: center;
  font-weight: 500;
  margin-top: 10px;
  opacity: 0.35;
}

.ecosystem-title-wrap {
  display: grid;
  justify-items: center;
  padding: 50px 10px 0;
  text-align: center;
}

.ecosystem-title-wrap > .title-small {
  padding: 0 50px;
  line-height: 22px;

  @media (min-width: 768px) {
    line-height: 33px;
  }
}

.ecosystem-subtitle {
  font-size: 16px;
  text-transform: uppercase;
  color: #504b53;
  margin-top: 14px;
  max-width: 698px;
  @media (min-width: 768px) {
    font-size: 18px;
  }
}

.ecosystem-actions {
  margin-top: 36px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 8px;

  @media (min-width: 320px) {
    grid-template-columns: 1fr 1fr;
    gap: 14px;
  }
}

.ecosystem-cards-wrap {
  display: grid;
  margin-top: 102px;
  box-sizing: border-box;
  width: calc(1200px + ((100% - 1200px) / 2));
  max-width: 100%;

  @media (min-width: 768px) {
    justify-self: flex-end;
    grid-template-columns: auto 1fr;
    margin-top: 160px;
  }
}

.ecosystem-cards-title {
  padding-left: 16px;
  font-weight: 300;
  font-size: 32px;
  text-transform: uppercase;
  line-height: 30px;
  color: #504b53;
}

.ecosystem-cards-title-label {
  color: #686868;
}

.ecosystem-cards {
  display: flex;
  gap: 14px;
  margin-top: 30px;
  overflow-x: auto;
  padding: 0 16px 16px;
  box-sizing: border-box;
  width: 100%;
  justify-self: flex-end;
  @media (min-width: 768px) {
    width: calc(50vw + 67px);
    padding: 0 67px 34px;
    margin-top: 0;
  }
}

.ecosystem-card {
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr auto;
  grid-template-areas:
    "title img"
    "title desc"
    "title link";
  column-gap: 20px;
  row-gap: 36px;
  height: 400px;
  flex: 0 0 min(340px, 90%);
  box-sizing: border-box;
  background: #28292e;
  padding: 40px;
  border-radius: 12px;
}

.ecosystem-card-title {
  writing-mode: vertical-rl;
  transform: rotate(180deg);
  text-orientation: mixed;
  color: #ffffff;
  font-size: 20px;
  grid-area: title;
}

.ecosystem-card-img {
  width: 108px;
  grid-area: img;
}

.ecosystem-card-desc {
  color: rgba(255, 255, 255, 0.5);
  font-size: 12px;
  grid-area: desc;
}

.ecosystem-card-link {
  display: inline;
  font-size: 12px;
  color: #ffffff;
  text-transform: uppercase;
  border-bottom: 1px #ffffff solid;
  padding: 0 2px;
  grid-area: link;
}

.social-title {
  font-size: 32px;
  text-transform: uppercase;
  line-height: 34px;
  text-align: center;

  @media (min-width: 768px) {
    line-height: 44px;
    padding: 0;
  }
}

.social-desc {
  font-size: 14px;
  color: #504b53;
  text-align: center;
  line-height: 16px;
  margin-top: 12px;
  margin-bottom: 16px;
  @media (min-width: 768px) {
    text-transform: uppercase;
    font-size: 16px;
  }
}

.blog-wrap {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas:
    "blog"
    "social";

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    grid-template-areas: "social blog";
  }
}

.blog-social-list {
  display: grid;
  justify-items: center;
  align-content: flex-start;
  grid-template-columns: repeat(3, 1fr);
  grid-area: social;
  margin-top: 16px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr;
    margin-top: 0;
    gap: 20px;
  }
}

.blog-social-item {
  display: grid;
  grid-template-columns: 1fr;
  padding: 24px;
  gap: 10px;
  justify-items: center;
  align-items: center;

  @media (min-width: 768px) {
    grid-template-columns: 1fr auto;
    gap: 20px;
  }
}

.blog-social-item-icon {
  width: 32px;
}

.blog-social-item-title {
  font-size: 14px;
  font-weight: 300;
  color: #504b53;

  @media (min-width: 768px) {
    font-size: 16px;
  }
}

.blog {
  padding: 24px;
  grid-area: blog;
}

.blog-title {
  color: #504b53;
  font-size: 16px;
  margin-bottom: 24px;
  @media (min-width: 768px) {
    font-weight: 300;
    margin-bottom: 10px;
  }
}

.blog-img {
  width: 100%;
  border-radius: 16px;
}

.blog-date {
  color: rgba(80, 75, 83, 0.7);
  font-size: 14px;
  margin-top: 24px;
  margin-bottom: 10px;
  @media (min-width: 768px) {
    display: none;
  }
}

.blog-desc {
  color: #504b53;
  font-size: 14px;
  @media (min-width: 768px) {
    margin-top: 14px;
    font-size: 12px;
  }
}

.footer {
  position: relative;
  display: flex;
  justify-content: center;
  background: #141519;
  padding: 30px 16px 90px;
  color: #ffffff;
  box-sizing: border-box;

  @media (min-width: 1024px) {
    padding: 56px 32px 328px;
  }
}

.footer::before {
  position: absolute;
  left: 0;
  top: -10px;
  content: "";
  background: #141519;
  height: 11px;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.footer-content {
  display: grid;
  width: 100%;
  max-width: 1200px;
  row-gap: 26px;
  grid-template-areas:
    "title title"
    "spacer-1 spacer-1"
    "token token"
    "switcher social"
    "spacer-2 spacer-2"
    "about about"
    "devs devs";

  @media (min-width: 1024px) {
    align-items: flex-start;
    row-gap: 32px;
    grid-template-columns: 1fr 1fr 220px;
    grid-template-areas:
      "about devs title"
      "about devs social"
      "spacer-1 spacer-1 spacer-2"
      "switcher switcher token";
  }
}

.footer-title {
  grid-area: title;
  font-weight: 600;
  font-size: 26px;

  @media (min-width: 1024px) {
    justify-self: flex-end;
  }
}

.footer-token {
  grid-area: token;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.footer-token-price {
  font-weight: 500;
  font-size: 20px;
  justify-self: flex-start;
}

.footer-token-btn {
  display: grid;
  gap: 8px;
  font-weight: 500;
  font-size: 14px;
  grid-template-columns: 1fr auto;
  align-items: center;
  background: #ffffff;
  padding: 0 16px;
  height: 32px;
  cursor: default;
  border-radius: 16px;
  color: #000000;
  opacity: 0.35;
}

.footer-switcher {
  grid-area: switcher;
}

.footer-social-list {
  display: grid;
  justify-self: flex-end;
  align-content: center;
  grid-template-columns: repeat(4, 20px);
  gap: 24px;
  grid-area: social;
  padding-right: 4px;
}

.footer-social-item {
  width: 20px;
  height: 20px;
}

.footer-about {
  grid-area: about;
}

.footer-devs {
  grid-area: devs;
}

.footer-spacer-1,
.footer-spacer-2 {
  height: 1px;
  background: #ffffff;
  width: 100%;
}

.footer-spacer-1 {
  grid-area: spacer-1;
}

.footer-spacer-2 {
  grid-area: spacer-2;
}

.footer-list {
  display: grid;
  gap: 8px;
}

.footer-list-title {
  font-size: 16px;
  font-weight: 500;
  color: #504b53;
  text-transform: uppercase;
}

.footer-list-item {
  width: min-content;
  white-space: nowrap;
  font-size: 16px;
}
</style>
